import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'
import { fetchCompanyDetails } from '../company-details/actions'

export const employerAccessTypes = createTypes([
        'REQUEST',
        'RECEIVE',
        'ERROR',
        'RECEIVE_ACTIVATE',
        'ERROR_ACTIVATE',
        'REQUEST_ACTIVATE',
        'SUCCESS',
        'ADD_EMPTY',
        'RECEIVE_REVOKE',
        'ERROR_REVOKE',
        'REQUEST_REVOKE'
    ], 'EMPLOYERACCESS');


export const requestEmployerAccess = (create=null) => {
    return {
        type: employerAccessTypes.REQUEST,
        create: create,
    };
};


export const receiveEmployerAccess = (response, create=null) => {
    return {
        type: employerAccessTypes.RECEIVE,
        data: response,
        create: create,
    };
};

export const receiveEmployerAccessError = (response, create=null) => {
    return {
        type: employerAccessTypes.ERROR,
        error: response,
        create: create,
    };
};

// Set current company, on link click 
export const setCurrentCompany = (response) => {
    return {

    };
};

export const fetchEmployerAccess = () => {
    return dispatch => {

        let success = true

        const apiUrl = `/api/v1/employeraccess/`

        dispatch(requestEmployerAccess());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveEmployerAccess(response));
            } else {
                dispatch(receiveEmployerAccessError(response))
            }
        })
        .catch(handleNetworkError);
    };
};


export const createEmployerAccess = (data) => {
    return dispatch => {

        let success = true

        const apiUrl = `/api/v1/employeraccess/`

        dispatch(requestEmployerAccess({[data.company_id]: 'init'}));

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken")
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(data)
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveEmployerAccess(response, {[data.company_id]: 'done'}));
            } else {
                dispatch(receiveEmployerAccessError(response, {[data.company_id]: 'error'}))
            }
        })
        .catch(handleNetworkError);
    };
};

export const requestEmployerAccessActivate = () => {
    return {
        type: employerAccessTypes.REQUEST_ACTIVATE,
    };
};

export const receiveEmployerAccessActivate = (response) => {
    return {
        type: employerAccessTypes.RECEIVE_ACTIVATE,
        data: response,
    };
};

export const receiveEmployerAccessActivateError = (response) => {
    return {
        type: employerAccessTypes.ERROR_ACTIVATE,
        error: response,
    };
};

export const activateEmployerAccess = (data) => {
    return dispatch => {

        let success = true

        const apiUrl = `/api/v1/employeraccess/`

        dispatch(requestEmployerAccessActivate());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken")
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'PUT',
            body: JSON.stringify(data)
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveEmployerAccessActivate(response));
                dispatch(fetchCompanyDetails(data.company_id));
            } else {
                dispatch(receiveEmployerAccessActivateError(response))
            }
        })
        .catch(handleNetworkError);
    };
};

export const requestEmployerAccessRevoke = () => {
    return {
        type: employerAccessTypes.REQUEST_REVOKE,
    };
};


export const receiveEmployerAccessRevoke = (response) => {
    return {
        type: employerAccessTypes.RECEIVE_REVOKE,
        data: response,
    };
};

export const receiveEmployerAccessRevokeError = (response) => {
    return {
        type: employerAccessTypes.ERROR_REVOKE,
        error: response,
    };
};

export const revokeEmployerAccess = (data) => {
    return dispatch => {

        let success = true

        const apiUrl = `/api/v1/employeraccess/`

        dispatch(requestEmployerAccessRevoke());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken")
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'DELETE',
            body: JSON.stringify(data)
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveEmployerAccessRevoke(response));
                dispatch(fetchCompanyDetails(data.company_id));
            } else {
                dispatch(receiveEmployerAccessRevokeError(response))
            }
        })
        .catch(handleNetworkError);
    };
};